import Layout from "@/views/layout/Layout.vue";
const module_system = [
  {
    path: "/system",
    component: Layout,
    children: [
      {
        path: "memberList",
        name: "memberList",
        component: () => import("@/views/system/MemberList"),
        meta: {
          title: "成员管理",
          needLogin: true
        }
      },
      {
        path: "roleList",
        name: "roleList",
        component: () => import("@/views/system/RoleList"),
        meta: {
          title: "角色管理",
          needLogin: true
        }
      },
      {
        path: "appList",
        name: "appList",
        component: () => import("@/views/system/AppList"),
        meta: {
          title: "APP管理",
          needLogin: true
        }
      },
      {
        path: "userManagement",
        name: "userManagement",
        component: () => import("@/views/system/userManagement"),
        meta: {
          title: "用户管理",
          needLogin: true
        }
      },
      {
        path: "userGroupManagement",
        name: "userGroupManagement",
        component: () => import("@/views/system/userGroupManagement"),
        meta: {
          title: "用户组管理",
          needLogin: true
        }
      },
      {
        path: "businessManagement",
        name: "businessManagement",
        component: () => import("@/views/system/businessManagement"),
        meta: {
          title: "用户管理",
          needLogin: true
        }
      },
      {
        path: "businessManagement-G",
        name: "businessManagement-G",
        component: () => import("@/views/system/businessManagement-G"),
        meta: {
          title: "企业管理政府版",
          needLogin: true
        }
      },

      // 2020.10.28 1.6新增
      {
        path: "earlyWarning",
        name: "earlyWarning",
        component: () => import("@/views/system/earlyWarning"),
        meta: {
          title: "预警系统",
          needLogin: true
        }
      },
      {
        path: "earlyWarning-G",
        name: "earlyWarning-G",
        component: () => import("@/views/system/earlyWarning-G"),
        meta: {
          title: "预警系统政府版",
          needLogin: true
        }
      },
      {
        path: "permissionSettings",
        name: "permissionSettings",
        component: () => import("@/views/system/permissionSettings"),
        meta: {
          title: "默认权限设置",
          needLogin: true
        }
      },
      {
        path: "permissionSettings-G",
        name: "permissionSettings-G",
        component: () => import("@/views/system/permissionSettings-G"),
        meta: {
          title: "默认权限设置政府版",
          needLogin: true
        }
      },
      {
        path: "addUser",
        name: "addUser",
        component: () => import("@/views/system/addUser"),
        meta: {
          title: "新增用户",
          needLogin: true
        }
      },
      {
        path: "generalSettings",
        name: "generalSettings",
        component: () => import("@/views/system/generalSettings"),
        meta: {
          title: "通用设置",
          needLogin: true
        }
      },
      {
        path: "customPermissions",
        name: "customPermissions",
        component: () => import("@/views/system/customPermissions"),
        meta: {
          title: "产品管理",
          needLogin: true
        }
      },
      {
        path: "customPermissions-G",
        name: "customPermissions-G",
        component: () => import("@/views/system/customPermissions-G"),
        meta: {
          title: "定制权限政府版",
          needLogin: true
        }
      },
      {
        path: "userManagement",
        name: "userManagement",
        component: () => import("@/views/system/userManagement"),
        meta: {
          title: "用户管理",
          needLogin: true
        }
      },
      {
        path: "roleManagement",
        name: "roleManagement",
        component: () => import("@/views/system/roleManagement"),
        meta: {
          title: "角色管理",
          needLogin: true
        }
      },
      {
        path: "authorityAssignment",
        name: "authorityAssignment",
        component: () => import("@/views/system/authorityAssignment"),
        meta: {
          title: "权限分配",
          needLogin: true
        }
      },
      {
        path: "userAssignment",
        name: "userAssignment",
        component: () => import("@/views/system/userAssignment"),
        meta: {
          title: "用户分配",
          needLogin: true
        }
      },
    ]
  }
];
export default module_system;
